<button class="open-button sstarabic" (click)="openForm()"><span class="circle-icone">
        <i class="pi pi-users" style="font-size: 1.4rem; color: black;"></i>
    </span>
    ({{users?.length}}) {{"Users"| translator}}</button>
<div *ngIf="users && users.length > 0">
    <div *ngIf="display" class="chat-popup elements" style="display: block !important;" id="myForm">
        <form action="/action_page.php" class="form-container">
            <div class="custom-scroll">
                <div *ngFor="let user of users" (click)="activateUser(user.uid)" class="containerr">
                    <div class="profile">
                        <i class="pi pi-user" style="font-size: 1.5rem"></i>
                        <div class="mx-2">
                            <h6 class="m-0 sstarabic text-black-50">{{user?.name}}</h6>
                            <p class="online">Online</p>
                        </div>
                    </div>
                    <div class="time">
                        <span class="time-left">{{user?.time?.substr(11,8)}}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button type="button" class="btn cancel" (click)="closeForm()"><i class="fa fa-times"></i></button>
            </div>
        </form>
    </div>
</div>